// cookie name for holding bearer/access token
export const AUTH_TOKEN = 'fairly-auth';

// cookie name for holding refresh token
export const REFRESH_TOKEN = 'fairly-refresh';

// cookie name for holding CSRF token
export const CSRF_TOKEN = 'fairly-csrf';

// cookie name for client debug flag
export const CLIENT_DEBUG = 'fairly-debug';

// Bull MQ arena host ID
export const ARENA_HOST_ID = 'Fairly App Server';

// GraphQL endpoint prefix
export const GRAPHQL_API_PREFIX = '/graphql';

// Bull MQ scheduler queue names
export const SCHEDULER_QUEUE_NAME = {
  task: 'task-scheduler',
  /*
   * Renamed from 'report-scheduler', and the rename is LOAD-BEARING — do not
   * "clean it up" back.
   *
   * Queue names are hardcoded and Redis is shared, so every process on the
   * same cache — old containers, other environments, a laptop with dev config
   * — is a competing consumer of the same queue. One such process, running
   * pre-fix code against its own database, kept executing dev's report jobs
   * and stamping them with errors the current codebase cannot produce
   * ("Template not found: <id>"). Which worker won was a coin flip, which is
   * why the failure survived every code fix, cache clear and queue purge.
   *
   * A name only the current build knows starves every stale consumer at once,
   * without having to find them. If this ever happens again, bump the suffix.
   */
  report: 'report-scheduler-v2',
};
// admin email
export const ADMIN_EMAIL = 'support@asenion.ai';

// Source Types
export const DATASET = 'dataset';
export const MODEL_RESULTS = 'model_results';

/**
 * localstorage key for keeping track is user has successfully signed in
 * (in any of the browser tab)
 * This is useful for alerting other browser tab, when the user has logged off
 */
export const IS_SIGNED_IN = 'isSignedIn';

/**
 * Is in production mode
 */
export function isProduction() {
  return typeof window !== 'undefined'
    ? window.__ENV__.NODE_ENV === 'production'
    : process.env.NODE_ENV === 'production';
}

/**
 * Isomorphic way to gain access to environment variables
 * NOTE: The client will only gain access to environment variables
 * that are explicitly passed into the window.__ENV__ variable
 */
export function envVar(): Record<string, string> {
  return typeof window !== 'undefined'
    ? window.__ENV__
    : (process.env as Record<string, string>);
}

/**
 * Returns true if code is running in browser
 */
export function isInBrowser() {
  return typeof window !== 'undefined';
}

/**
 *
 * @returns if postgres should be used
 */
export function isUsePostgres() {
  return false;
}

//policy labels
export const HIDE_ASSESSMENT_DETAILS = 'report.project.assessment_details.hide';
export const OPERATIONAL_RISKS = 'Operational Risks';
export const EXECUTIVE_SUMMARY_CONTROL_ID =
  'com.fairly.ai.project.evaluation.executive.summary';
export const ASSESSMENT_METHODOLOGY_CONTROL_ID =
  'com.fairly.ai.project.evaluation.assessment.methodology';

/**
 * Default screening policy identifiers per creation context.
 * Used as fallbacks when no PolicyRule with source=SCREENING matches
 * the requested ScreeningCreationContext.
 */
export const DEFAULT_SCREENING_POLICY_ORG =
  'com.anch.ai.navigator.setup-organization';
export const DEFAULT_SCREENING_POLICY_AI_SYSTEM =
  'com.anch.ai.navigator.setup-usecase';
